import * as Actions from 'wix/actions';
import * as Types from 'wix/actions/types';
import Api from 'wix/apiClient';

import {
  agreement,
  CREATE_WEBSITE_FAILED,
  CREATE_WEBSITE_REQUEST,
  CREATE_WEBSITE_SUCCEEDED,
  createWebsiteFailed,
  createWebsiteSucceeded,
  UPDATE_SETTINGS_FAILED,
  UPDATE_SETTINGS_SUCCEEDED,
  updateSettings,
} from '@va/dashboard/actions/api';
import { REGISTER } from '@va/dashboard/actions/app';
import { updateWebsiteLocale } from '@va/dashboard/sagas/api';
import { getAuthenticationInstance, getInstanceId } from '@va/dashboard/selectors/app';
import { getWebsiteUrl, hasWebsite } from '@va/dashboard/selectors/core';
import { getLocale } from '@va/dashboard/selectors/ui';
import { UPDATE_WEBSITE_LOCALE_REQUEST } from '@va/standalone/shared/actions';
import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';

export function* watchers() {
  yield all([
    takeLatest(CREATE_WEBSITE_REQUEST, createWebsite),
    takeLatest(REGISTER, register),
    takeLatest(Types.wix.Api.ACTIVATE_DIRECT_ACCESS_REQUEST, activateDirectAccess),
    takeLatest(UPDATE_WEBSITE_LOCALE_REQUEST, updateWebsiteLocale),
  ]);
}

export function* createWebsite(action) {
  try {
    const instance = yield select(getAuthenticationInstance);
    const locale = yield select(getLocale);
    const siteUrl = yield select(getWebsiteUrl);

    const requestData = {
      instance,
      email: action.data.get('email', '').trim(),
      firstName: action.data.get('firstName', '').trim(),
      lastName: action.data.get('lastName', '').trim(),
      company: action.data.get('companyName', '').trim(),
      timezone: action.data.get('timezone'),
      cookiesAccepted: action.data.get('cookiesAccepted', false),
      websiteUrl: siteUrl,
      locale: locale,
    };

    const data = yield call(Api.createWebsite, requestData);

    yield put(createWebsiteSucceeded(data));
    if (action.data.get('termsAndDpaAccepted')) yield put(agreement());
  } catch (error) {
    yield put(createWebsiteFailed(error));
  }
}

export function* register(action) {
  const websiteExists = yield select(hasWebsite);
  if (websiteExists) {
    yield put(updateSettings(action.data));

    const response = yield take([UPDATE_SETTINGS_SUCCEEDED, UPDATE_SETTINGS_FAILED]);
    if (response.type === UPDATE_SETTINGS_SUCCEEDED) {
      if (action.data.get('termsAndDpaAccepted')) yield put(agreement());
      yield put(
        createWebsiteSucceeded({
          hasFirstLogin: true,
          email: action.data.get('email').trim(),
        }),
      );
    }
  } else {
    yield put(createWebsite(action.data));

    const response = yield take([CREATE_WEBSITE_SUCCEEDED, CREATE_WEBSITE_FAILED]);
    if (response.type === CREATE_WEBSITE_SUCCEEDED) {
      yield put(
        createWebsiteSucceeded({
          hasFirstLogin: true,
          email: action.data.get('email').trim(),
        }),
      );
    }
  }
}

export function* activateDirectAccess(action) {
  try {
    const websiteId = yield select(getInstanceId);
    const data = {
      email: action.email.get('emailActivate').trim(),
    };
    yield call(Api.activateDirectAccess, websiteId, data);
    yield put(Actions.wix.Api.activateDirectAccessSucceeded());
    yield put(Actions.wix.App.migrationEmailSent(true));
  } catch (error) {
    yield put(Actions.wix.Api.activateDirectAccessFailed(error));
  }
}
